import extend from 'just-extend';

/**
 *
 * Works in the same fashion as Object.Assign() by deep merging
 *
 * @param {...Object} objs - N nuber of objects
 * @return {Object} Combined object
 *
 */
function deepMerge(...objs) {
    return extend(true, {}, ...objs);
}

export { deepMerge };
